import CramCodec from './_base';
import { getBits } from './getBits';
import { CramUnimplementedError } from '../../errors';
export default class BetaCodec extends CramCodec {
    constructor(parameters, dataType) {
        super(parameters, dataType);
        if (this.dataType !== 'int') {
            throw new CramUnimplementedError(`${this.dataType} decoding not yet implemented by BETA codec`);
        }
    }
    decode(slice, coreDataBlock, blocksByContentId, cursors) {
        const fromBits = getBits(coreDataBlock.content, cursors.coreBlock, this.parameters.length);
        return fromBits - this.parameters.offset;
    }
}
//# sourceMappingURL=beta.js.map